import { useUserContext } from '@/contexts/user';
import { computeBlockedModulesActive } from '@/config/blockedModules';

type UseBlockedModule = {
  isFeatureEnabled: boolean;
};

export const useBlockedModule = (): UseBlockedModule => {
  const { userSession } = useUserContext();
  return {
    isFeatureEnabled: computeBlockedModulesActive(userSession?.country),
  };
};
